export const SET_USER = "SET_USER";
export const UPDATE_USER_ROLE = "UPDATE_USER_ROLE";
